import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=59123094&scoped=true"
import script from "./rule.vue?vue&type=script&lang=ts&setup=true"
export * from "./rule.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./rule.vue?vue&type=style&index=0&id=59123094&prod&lang=less"
import style1 from "./rule.vue?vue&type=style&index=1&id=59123094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59123094",
  null
  
)

export default component.exports